import React, { Component } from 'react';
import Content from './Content';

export default class App extends Component {
  render() {
    return (
      <>
        <Content />
      </>
    );
  }
}
